import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { SortSelect } from "@/components/SortSelect";
import { useCollections } from "@/context/CollectionsContext";

const LEGACY_TITLES = { men: "Men's", women: "Women's", accessories: "Accessories", all: "Shop All" };
const BANNERS = {
  men: "https://images.pexels.com/photos/8068701/pexels-photo-8068701.jpeg",
  women: "https://images.pexels.com/photos/8007208/pexels-photo-8007208.jpeg",
  "shop-women": "https://customer-assets-jai6qajn.emergentagent.net/job_rock-hard-tennis/artifacts/78o8mj69_hf_20260618_160757_2a09ecf2-7758-4b53-b817-fe977715d838.webp",
  accessories: "https://images.unsplash.com/photo-1591100464007-37ec1ccc6224",
  all: "https://images.unsplash.com/photo-1554068865-24cecd4e34b8",
};

export default function Shop() {
  const { category = "all" } = useParams();
  const collections = useCollections();
  const [params, setParams] = useSearchParams();
  const sort = params.get("sort") || "featured";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const matched = collections.find((c) => c.handle === category);
  const isLegacy = ["men", "women", "accessories"].includes(category);
  const title = category === "all" ? "Shop All"
    : matched ? matched.title
    : LEGACY_TITLES[category] || category.replace(/-/g, " ");

  useEffect(() => {
    setLoading(true);
    const query = { sort };
    if (category !== "all") {
      if (matched || (!isLegacy)) query.collection = category;
      else query.category = category;
    }
    if (category === "all" || category === "best-sellers") {
      query.exclude = "teams,halloween";
    }
    const qs = new URLSearchParams(query).toString();
    api.get(`/products?${qs}`)
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [category, sort, matched, isLegacy]);

  const setSort = (v) => setParams(v === "featured" ? {} : { sort: v }, { replace: true });

  return (
    <div className="pt-20" data-testid="shop-page">
      <section className="relative h-[40vh] overflow-hidden">
        <img src={BANNERS[category] || BANNERS.all} alt={title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-ink/55 flex items-center justify-center">
          <h1 className="font-display text-cream text-5xl md:text-7xl uppercase text-center px-4" data-testid="shop-title">{title}</h1>
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="flex justify-between items-center mb-8 gap-4 flex-wrap">
          <p className="text-xs font-bold uppercase tracking-widest text-gray-500">{products.length} Products</p>
          <SortSelect value={sort} onChange={setSort} />
        </div>
        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[...Array(8)].map((_, i) => <div key={i} className="aspect-[4/5] bg-gray-100 animate-pulse" />)}
          </div>
        ) : products.length === 0 ? (
          <p className="text-center py-20 uppercase tracking-widest text-gray-400">No products found.</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-10 md:gap-x-6 md:gap-y-12">
            {products.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
          </div>
        )}
      </section>
    </div>
  );
}
